/* functions temporaires juste pour tests composants */

import { isNumberArray } from "@tanstack/react-table";
import { configurations_getDefaultParams } from "../../../utils/configurations";
import { V2_framesToSeconds } from "../../../utils/timecodev2";
export function scriptRecomputeFromApp(script, stparams)
{
    const wordDuration = 60 / stparams.speechRateMM;
    const charDuration = 1/ stparams.speechRate;
    scriptRecomputeAllTimeCode(script, wordDuration,charDuration, stparams.speechRateMode);
}


function scriptRecomputeAllTimeCode(script, wordDuration,charDuration, lisibilityMode)
{

    var currentWord = 0;
    var nextWord = -1;
    const sizeScript = script.length; 
    if (sizeScript < 1) return; // rien à faire

    var startTimeCode = 0;

    var thatsAllFolk = false;
    while (!thatsAllFolk)
    {
        if (getTCIn(script,currentWord) !== -1) startTimeCode = getTCIn(script,currentWord);
        // on recherche une séquence entre currentWord et la fin
        // la séquence commence au time code startTimeCode

        // on regarde d'abord sur le mot en cours
        var tcout = -1;
        var indexout = currentWord;
        var cas ="cas 0";
        if (getTCOut(script,currentWord) !== -1)
        {
            tcout = getTCOut(script,currentWord);
            indexout = currentWord;
            nextWord = currentWord + 1;
            if (nextWord >= sizeScript) thatsAllFolk = true;
            cas ="cas 1";
            
        }
        else
        {
          var tc = getFirstTCINOUTFromIndex(script,currentWord + 1);
          if (tc.index === -1)
          {
              indexout = sizeScript -1;
              nextWord = sizeScript;
              tcout = -1;
              thatsAllFolk = true; // c'était le dernier
              cas ="cas 2";

          }
          else
          {
            if (tc.type === "in")
            {
                // on arrete au mot avant
                indexout = tc.index - 1;
                nextWord = tc.index;
                tcout = tc.tc;
                cas ="cas 3";
            }
            else
            {
              // le prochain est un out
                indexout = tc.index;
                nextWord = indexout+1;
                tcout = tc.tc;
                cas ="cas 4";
            }
          }
        }

        // on gère la séquence

        

        // on cherche la durée ideale du script
        var dureeideale = 0;
        var nbchar = 0;
        var nbmot = 0; // nombre de mot reel
        var nbword = 0; // nombre de groupe de mot
        for (var i=currentWord; i<= indexout; i++)
        {
          const mots = script[i].text.trim().split(/\s+/);
          nbmot += mots.length;
          nbword++;
          nbchar += script[i].text.length;
        }

        
        

        if (lisibilityMode !== 0)
          dureeideale = nbmot * wordDuration;
        else
          dureeideale = nbchar * charDuration;

        var dureepossible = tcout - startTimeCode;

        
        if (tcout == -1 ) dureepossible= dureeideale;
        

        var dureeretenue = dureeideale;
        if (dureeretenue > dureepossible) dureeretenue = dureepossible;

        

        // c'est parti.....

        if (lisibilityMode !== 0)
        {
          var lasttcout = startTimeCode;
          var nbmtrait = 0;
          for (var i= currentWord; i<= indexout; i++)
          {
              script[i].startTime = lasttcout;
              nbmtrait = nbmtrait + 1;
              script[i].endTime = startTimeCode + (dureeretenue * nbmtrait) / nbword;
              lasttcout = script[i].endTime;

          }

        }
        else
        {

          var lasttcout = startTimeCode;
          var nbctrait = 0;
          for (var i= currentWord; i<= indexout; i++)
          {
              script[i].startTime = lasttcout;
              nbctrait = nbctrait + script[i].text.length;
              script[i].endTime = startTimeCode + (dureeretenue * nbctrait) / nbchar;
              lasttcout = script[i].endTime;

          }
        }



        currentWord = nextWord;
        startTimeCode = tcout;

    }



}


function getTCIn(script,index)
{
    if ((script[index].markWord & 4) !== 0)
      return script[index].startTime;
    return -1;
}

function getTCOut(script,index)
{
    if ((script[index].markWord & 8) !== 0)
      return script[index].endTime;
    return -1;
}

function getFirstTCINOUTFromIndex(script,index)
{
    // on cherche le premier time code in ou out par rapport à index
    const nbword = script.length;
    for (var i = index; i < nbword ; i++)
    {
      if (getTCIn(script, i) !== -1) return {index:i,type:"in", tc:script[i].startTime};
      if (getTCOut(script, i) !== -1) return {index:i,type:"out", tc:script[i].endTime};
    }
    return {index:-1,type:"", tc:-1}; // plus rien après
}

function getLastTCINOUTFromIndex(script,index)
{
    // on cherche le premier time code in ou out par rapport à index en arriere
    for (var i = index; i>=0 ; i--)
    {
      if (getTCOut(script, i) !== -1) return {index:i,type:"out", tc:script[i].endTime};
      if (getTCIn(script, i) !== -1) return {index:i,type:"in", tc:script[i].startTime};
    }
    return {index:-1,type:"", tc:-1}; // plus rien avant
}


function isPossibleTCIN(script,index, timecode)
{
    // test si on peut accepter ce time code en time code IN
    // on cherche le time code après le in
    // d'abord le out de l'index
    var tc = getTCOut(script,index);
    if ((tc !==-1 ) && (timecode > tc)) return false; 
    if (tc !==-1) return true;
    tc = getFirstTCINOUTFromIndex (script,index +1 );
    if ((tc.index !==-1 ) && (timecode > tc.tc)) return false; 

    // pas de problème avec les mots après
    // on regarde avec ceux avant

    tc = getLastTCINOUTFromIndex (script,index -1 );
    if ((tc.index !== -1) && (timecode < tc.tc)) return false;
    return true;

}


function isPossibleTCOUT(script,index, timecode)
{
    // test si on peut accepter ce time code en time code OUT
    // on cherche le time code après le in
    // d'abord le out de l'index
    var tc = getTCIn(script,index);
    if ((tc !==-1 ) && (timecode < tc)) return false; 
    if (tc !== -1) return true;
    tc = getFirstTCINOUTFromIndex (script,index +1 );
    if ((tc.index !==-1 ) && (timecode > tc.tc)) return false; 

    // pas de problème avec les mots après
    // on regarde avec ceux avant

    tc = getLastTCINOUTFromIndex (script,index -1 );
    if ((tc.index !== -1) && (timecode < tc.tc)) return false;
    return true;

}



export function createNewTimeCodesForTranscription (script, wordIndex, atEnd, timecode, stparams, undoFunction=null)
{

    
    var defaultconf = configurations_getDefaultParams();

    if (!("speechRateMode" in stparams))
        stparams.stickEndSentence = defaultconf.speechRateMode;
    if (!("speechRate" in stparams))
        stparams.stickEndSentence = defaultconf.speechRate;
    if (!("speechRateMM" in stparams))
        stparams.stickEndSentence = defaultconf.speechRateMM;


    const wordDuration = 60 / stparams.speechRateMM;
    const charDuration = 1/ stparams.speechRate;


    
    

    if ((wordIndex < 0) || (wordIndex >= script.length)) return;


    if (!atEnd) // time code au début d'un mot
    {
      // on défini un nouveau time code In
      if (getTCIn(script,wordIndex) !== -1)
      {
        // il y a déjà un markIn
        if (undoFunction) undoFunction("changeTimeCode");
        script[wordIndex].markWord -= 4;
        scriptRecomputeAllTimeCode(script, wordDuration,charDuration, stparams.speechRateMode);
        return;
      }

      // on test si c'est possible
      // 

      if (isPossibleTCIN (script, wordIndex,timecode))

      {
        if (undoFunction) undoFunction("changeTimeCode");
        script[wordIndex].markWord += 4;
        script[wordIndex].startTime = timecode;

        scriptRecomputeAllTimeCode(script, wordDuration,charDuration, stparams.speechRateMode);
      }
      
    }
    else
    {

        // ici on repere un time code out
      if (getTCOut(script,wordIndex) !== -1)
      {
        // il y a déjà un markout
        if (undoFunction) undoFunction("changeTimeCode");
        script[wordIndex].markWord -=8;
        scriptRecomputeAllTimeCode(script, wordDuration,charDuration, stparams.speechRateMode);
        return;
      }

      if (isPossibleTCOUT (script, wordIndex,timecode))

      {
        if (undoFunction) undoFunction("changeTimeCode");
        script[wordIndex].markWord +=8;
        script[wordIndex].endTime = timecode;

        scriptRecomputeAllTimeCode(script, wordDuration,charDuration, stparams.speechRateMode);
      }


    }

    

}




function computeAllTimeCodeTranscription(transcription)
{
    const stparams = configurations_getDefaultParams();
    // recherche du nombre de caractère
    var nbc = 0;
    transcription.forEach( word=>{
        nbc+= word.text.length;
    });
    const dureetotale = nbc / stparams.lisibility;
    var lasttcout = 0;
    var nbctrait = 0;

    transcription.forEach( word=>{
        word.startTime = lasttcout;
        nbctrait += word.text.length;
        word.endTime  = (dureetotale * nbctrait) / nbc;
        lasttcout = word.endTime;
    });

    return transcription;



}


function rtfToPlainText(rtf) {
  return rtf
    // Supprimer séquences hexadécimales RTF en lettres accentuées
    .replace(/\\'([0-9A-Fa-f]{2})/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    )
    // Supprimer les groupes de contrôle comme {\fonttbl...}, {\*\generator...}, etc.
    .replace(/{\\\*?[^{}]+{[^{}]+}}/g, "")
    .replace(/{\\[^{}]+}/g, "")
    // Remplacer \par par des retours à la ligne
    .replace(/\\pard/g, "\n")
    .replace(/\\par[d]?/g, "\n")
    // Supprimer toutes les commandes RTF restantes \xxx123…
    .replace(/\\[a-zA-Z]+\d* ?/g, "")
    // Supprimer toutes les accolades restantes
    .replace(/[{}]/g, "")
    // Nettoyer les espaces inutiles
    .replace(/ +/g, " ")
    // Nettoyer les retours à la ligne multiples
    .replace(/\n{2,}/g, "\n")
    .trim();
}


export function convertTextFileToJson(text, isRTF = false)
{
  var ret = [];
  
  if (isRTF)
    text = rtfToPlainText(text);

  // on commence par extraire les lignes
  const phrases = text.split(/\r\n|\r|\n/);
  // Optionnel: enlever les vides, les espaces parasites
  const resultat = phrases.map(p => p.trim()).filter(p => p.length > 0);  


  resultat.forEach ((phrase) => 
  {
    const mots = phrase.trim().split(/\s+/);
    var nextNewLine = true;
    mots.forEach ((word) =>
      {
          var newword = {
            text: word,
            startTime: 0,
            endTime: 0,
            newline: nextNewLine,
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            color: '#FFFFFF',
            italic: false,
            markWord: 0,
          };

          newword.text = newword.text.replace(/([^ \n])([?!:])/g, '$1 $2');
          ret.push(newword);
          const lastChar = newword.text.slice(-1);
          nextNewLine = '.?!'.includes(lastChar);

    });


  });
  ret = computeAllTimeCodeTranscription(ret);
  return ret;
}



function createEmptySequence()
{
  return { 
      in:0,    
      out:0,
      emotion: "neutral",
      status:"autoGenerated",
      title: "Empty sequence",
      description: "",
      subjects:[],
    }
}


function findSceneIndex(array, scene_index) {
    return array.findIndex(
        element => element.scene_index === scene_index
    );
}

function getSceneTitle (array, scene_index)
{
    const ind = findSceneIndex (array,scene_index);
    if (ind === -1) return "Scene not found";
    return array[ind].scene_desc;
}

  


export function convertTranscriptionScriptToSequences(json,pjid,num=25,den=1,dropframe=0)
{
  var lessequences = {
    pjid: pjid,
    sequences: [],
  };
  var sequences = [];

  if (("scenes" in json) && ("transcription" in json))
  {

      var lasttimein = 0;
      var lasttimeout = 0;
      var lastsequence = "";

      json.transcription.forEach(word =>
      {

        //var start_time =  V2_framesToSeconds(word.startTime,num,den,dropframe);
        //var end_time =  V2_framesToSeconds(word.endTime,num,den,dropframe);

        var start_time =  word.startTime;
        var end_time =  word.endTime;

        var sind=""; if ("scene_index" in word) sind = word.scene_index;
        if (sind !== "")
        {
            if (lastsequence === "")
            {
                lasttimein = start_time;
                lasttimeout = end_time;
                lastsequence = sind;
            }
            else
            {
              if (sind === lastsequence)
              {
                  lasttimeout = end_time;
              }
              else
              {
                  // on écrit la séquence
                var seq = createEmptySequence();
                seq.in = lasttimein;
                seq.out = lasttimeout;
                if ((lastsequence) && (lastsequence.trim() !== ""))
                  seq.title = lastsequence.trim()+" "+getSceneTitle(json.scenes, lastsequence);
                else
                  seq.title = getSceneTitle(json.scenes, lastsequence);
                seq.description = "";
                sequences.push (seq);
                
                lasttimein = start_time;
                lasttimeout = end_time;
                lastsequence = sind;

              }
            }
        }


      })

      // c'est fini
      if (lastsequence !=="")
      {
          var seq = createEmptySequence();
          seq.in = lasttimein;
          seq.out = lasttimeout;
          seq.title = getSceneTitle(json.scenes, lastsequence);
          seq.description = lastsequence;
          sequences.push (seq);
      }


      console.log("sequence avant ajout")

      if (sequences.length != 0)
      {
        if (sequences[0].in < 1.0)
        {
          sequences[0].in = 0;
          lessequences.sequences.push (sequences[0]);
        }
        else
        {
          var seq = createEmptySequence();
          seq.in = 0;
          seq.out = sequences[0].in;
          seq.title = "Empty sequence";
          seq.description = "Empty sequence";
          seq.status = "Empty";
          lessequences.sequences.push (seq);

          lessequences.sequences.push (sequences[0]);

        }

        for (var i = 1; i<sequences.length ; i++)
        {
          if ((sequences[i].in - sequences[i-1].out) < 1.0)
          {
            sequences[i].in = sequences[i-1].out;
            lessequences.sequences.push (sequences[i]);
          }
          else
          {
            var seq = createEmptySequence();
            seq.in = sequences[i-1].out;
            seq.out = sequences[i].in;
            seq.title = "Empty sequence";
            seq.description = "Empty sequence";
            seq.status = "Empty";
            lessequences.sequences.push (seq);

            lessequences.sequences.push (sequences[i]);

          }
        }
        

      }


      return lessequences;
  }
  else
    return null;

}



export function convertTranscriptionScriptType0(json,num=25,den=1,dropframe=0) 
{

  
    var ret = [];
    var nextNewLine = false;
    

    // est-ce du whisper ?
    if (json.segments)
    {
        
        json.segments.forEach((onesegment) => {
          if (onesegment.words)
          {
            onesegment.words.forEach((oneword) => {
              var newword = 
              {
                text: oneword.word.trim(),
                startTime: oneword.start,
                endTime: oneword.end,
                newline: nextNewLine,
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                color: '#FFFFFF',
                italic: false,
                markWord: 0,
                }
              
              ret.push(newword);
              const lastChar = newword.text.slice(-1);
              nextNewLine = '.?!'.includes(lastChar);
        
            })
          }

        })
        return ret;
    };
    
    json.words.forEach((oneword) => {
      
      if (oneword.startTime)
        {
          var newword = {
            text: oneword.content.trim(),
            startTime: oneword.startTime,
            endTime: oneword.endTime,
            newline: nextNewLine,
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            color: '#FFFFFF',
            italic: false,
            markWord: 0,
          };
    
        }
        else
        {

          var newword = {
            text: oneword.content.trim(),
            startTime: V2_framesToSeconds(oneword.start_time,num,den,dropframe),
            endTime: V2_framesToSeconds(oneword.end_time,num,den,dropframe),
            newline: nextNewLine,
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            color: '#FFFFFF',
            italic: false,
            markWord: 0,
            speakerId: (("speaker_id" in oneword) && (typeof oneword.speaker_id === "string"))?oneword.speaker_id:""
          };
        }

        newword.text = newword.text.replace(/([^ \n])([?!:])/g, '$1 $2');
        ret.push(newword);
  
      const lastChar = newword.text.slice(-1);
      nextNewLine = '.?!'.includes(lastChar);
    });
  
    var speakers = [];
    if ("speakers" in json)
    {
      json.speakers.forEach(speaker =>{

        if ("name" in speaker)
        {
          speakers.push ({ id: speaker.id, name: speaker.name})
        }
        else
          speakers.push ({ id: speaker.id, name: "speaker_"+speaker.id})
      })

    }

    var transcription ={
      transcription: ret,
      speakers: speakers,
    }
    return transcription;
  }
  
  export const directDownloadJson = (url, callbackfn, infos) => {
    var myHeaders = new Headers();
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Content-Type', 'application/json');
  
    var myInit = { method: 'POST', Headers: myHeaders, mode: 'cors' };
    fetch(url, myInit)
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((data) => {
        callbackfn(data, infos, url);
      })
  
      .catch((err) => {
        console.log(err);
      });
  };
  
  // **************************************************************************************************************
  // keyboard shortcuts
  // **************************************************************************************************************
  
  
  const videoShortCuts = [
    {
      key: 'PLAY',
      fr: 'Play/Stop',
      en: 'Play/Stop',
      code: 'ArrowUp',
      shift: false,
      ctrl: false,
      alt: true,
    },
    {
      key: 'STOP',
      fr: 'Stop',
      en: 'Play',
      code: 'ArrowDown',
      shift: false,
      ctrl: false,
      alt: true,
    },
    {
      key: 'NEXTF',
      fr: 'Avance une image',
      en: 'Next Frame',
      code: 'PageDown',
      shift: false,
      ctrl: false,
      alt: true,
    },
    {
      key: 'PREVF',
      fr: 'Recule une image',
      en: 'Previous Frame',
      code: 'PageUp',
      shift: false,
      ctrl: false,
      alt: true,
    },
    {
      key: 'NEXT30',
      fr: 'Avance 30s',
      en: 'Go Forward 30s',
      code: 'ArrowRight',
      shift: false,
      ctrl: false,
      alt: true,
    },
    {
      key: 'PREV30',
      fr: 'Recule 30s',
      en: 'Go Back 30s',
      code: 'ArrowLeft',
      shift: false,
      ctrl: false,
      alt: true,
    },
  ];
  
  // to find a key in https://keycode.space/
  const transcriptShortCuts = [
    {
      key: 'LEFT',
      fr: 'Curseur vers la gauche',
      en: 'Cursor Left',
      code: 'ArrowLeft',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'RIGHT',
      fr: 'Curseur vers la droite',
      en: 'Cursor Right',
      code: 'ArrowRight',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'DOWN',
      fr: 'Curseur vers le bas',
      en: 'Cursor Down',
      code: 'ArrowDown',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'UP',
      fr: 'Curseur vers le haut',
      en: 'Cursor Up',
      code: 'ArrowUp',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'SAVE',
      fr: 'Sauvegarde',
      en: 'Save',
      code: 's',
      shift: false,
      ctrl: true,
      alt: false,
    },
    {
      key: 'BACKSPACE',
      fr: 'Retour',
      en: 'Backspace',
      code: 'Backspace',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'ENTER',
      fr: 'Entrée',
      en: 'Enter',
      code: 'Enter',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'DELETE',
      fr: 'Supprimer',
      en: 'Delete',
      code: 'Delete',
      shift: false,
      ctrl: false,
      alt: false,
    },
    {
      key: 'CHECKWORD',
      fr: "Marquer le mot avec l'icône !",
      en: 'Mark the word with the ! icon',
      code: 'x',
      shift: false,
      ctrl: true,
      alt: false,
    },
    {
      key: 'NEWST',
      fr: "Marquer le mot avec l'icône new",
      en: 'Mark the word with the new icon',
      code: 'y',
      shift: false,
      ctrl: true,
      alt: false,
    },
  ];
  
  const markWordKeys = [
    {
      key: 'CHECKWORD',
      value: 1,
      icon: 'checkst.png',
    },
    {
      key: 'NEWST',
      value: 2,
      icon: 'newst.png',
    },
    /*{
      key: 'CTRLZ',
      value: 4,
    },
    {
      key: 'CTRLA',
      value: 8,
    },
    {
      key: 'CTRLB',
      value: 16,
    },*/
  ];
  
  export function getMarkWord(key) {
    return markWordKeys.find((x) => x.key === key);
  }
  
  // Trouver les bonnes clés avec la suite géométrique
  export function findMarkWords(target) {
    return markWordKeys.filter((item) => (target & item.value) !== 0);
  }
  
  function getKey(shortcuts, code, shift, ctrl, alt) {
    const foundKey = shortcuts.find(
      (u) =>
        u.code === code && u.shift === shift && u.ctrl === ctrl && u.alt === alt
    );
    if (foundKey) return foundKey.key;
    return '';
  }
  
  
  export function secondsToTimecodeWithMilliseconds(totalSeconds) {
    // Calculer les heures, minutes, secondes et millisecondes
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const milliseconds = Math.floor((totalSeconds * 1000) % 1000); // Extraire les millisecondes
  
    // Formater en ajoutant des zéros devant si nécessaire
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');
    const millisecondsStr = milliseconds.toString().padStart(3, '0'); // 3 chiffres pour les millisecondes
  
    return `${hoursStr}:${minutesStr}:${secondsStr}.${millisecondsStr}`;
  }
  
  export function timeToTimecodeWithFrames(seconds, fps = 25) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
  
    // Calculate frames based on the FPS rate
    const frames = Math.floor((seconds % 1) * fps);
  
    // Format with leading zeros
    const formattedHrs = hrs.toString().padStart(2, '0');
    const formattedMins = mins.toString().padStart(2, '0');
    const formattedSecs = secs.toString().padStart(2, '0');
    const formattedFrames = frames.toString().padStart(2, '0'); // Two-digit frames
  
    return `${formattedHrs}:${formattedMins}:${formattedSecs}:${formattedFrames}`;
  }
  
  // Utilise une fonction pour tronquer à 6 décimales sans arrondir
  export function truncateTimeCode(num) {
    return Math.trunc(num * 1e6) / 1e6;
  };